module.exports = {"id":"214665","name":"Juan Ramírez","rating":"71","photo":"./data/images/photos/0/214665.png","club":{"name":"CA Talleres","logo":"./data/images/clubs/CATalleres.png"},"positions":["MG","MC","AG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanRamirez0.json
// module id = 2224
// module chunks = 0